import { isSubscriptionPopupVisibile, subscriptionPopupConfig } from '../subscriptionPopup';
import { createCookie, readCookie } from '../cookieUtils';
import jrRightsideProposalTemplate from '../../view/angular/serp/rightside-proposal.tpl.html';
import googleOneTapModalConfirmTemplate from '../../view/angular/serp/modal/modal-auto-one-tap-confirm-subscription.tpl.html';
import modalAutoConfirmSubscriptionTemplate from '../../view/angular/serp/modal/modal-auto-confirm-subscription.tpl.html';

angular
  .module('jrProposal', [
    'jrConfig',
    'jrUtil',
    'jrEvents',
    'jrSubscription',
    'jrModal',
    'jrLinkToInbox',
    'jrGoogleTagManager',
    'jrTracking',
    'jrCommonService',
  ])
  .value('createCookie', createCookie)
  .value('readCookie', readCookie)
  .value('isSubscriptionPopupVisibile', isSubscriptionPopupVisibile)
  .value('subscriptionPopupConfig', subscriptionPopupConfig)
  .value('jrRightsideProposalTemplate', jrRightsideProposalTemplate)
  .value('googleOneTapModalConfirmTemplate', googleOneTapModalConfirmTemplate)
  .value('modalAutoConfirmSubscriptionTemplate', modalAutoConfirmSubscriptionTemplate)
  .directive('jrAutoSubscriptionProposal', [
    '$rootScope',
    'SearchConfig',
    'SearchFormService',
    'ModalProposalService',
    'GoogleTagManagerTrackingService',
    'SubscriptionConfig',
    'createCookie',
    'readCookie',
    'isSubscriptionPopupVisibile',
    'subscriptionPopupConfig',
    function (
      $rootScope,
      SearchConfig,
      SearchFormService,
      ModalProposalService,
      GoogleTagManagerTrackingService,
      SubscriptionConfig,
      createCookie,
      readCookie,
      isSubscriptionPopupVisibile,
      subscriptionPopupConfig
    ) {
      return {
        link(scope, element, attrs) {
          if (SubscriptionConfig.popupPolicyType === subscriptionPopupConfig.NO_POPUP) {
            return;
          }

          const cookieValue = readCookie(subscriptionPopupConfig.COOKIE_NAME) || null;

          const callbackFunction = function () {
            // Tracking
            GoogleTagManagerTrackingService.trackAutoProposal(SubscriptionConfig.popupPolicyType);

            const modal = ModalProposalService.openModalProposal({
              resolve: {
                search() {
                  return angular.copy(SearchFormService.search);
                },
              },
              windowClass: getModalClasses(),
              backdrop: true,
            });
            const newCookieValue = !cookieValue ? 1 : parseInt(cookieValue, 10) + 1;

            createCookie(
              subscriptionPopupConfig.COOKIE_NAME,
              newCookieValue,
              subscriptionPopupConfig.COOKIE_EXPIRES
            );

            modal.opened.then(function () {
              $rootScope.subscriptionModal = modal;

              if (
                SearchConfig.isSubscriptionCaptchaEnabled &&
                !$rootScope.SubscriptionModalCaptcha
              ) {
                element.ready(function () {
                  $rootScope.SubscriptionModalCaptcha = grecaptcha.render('captcha-container', {
                    sitekey: jrConfigGlobal.captcha.siteKey,
                  });
                });
              }
            });
          };

          if (isSubscriptionPopupVisibile(cookieValue)) {
            callbackFunction();
          } else if (
            SubscriptionConfig.popupPolicyType === subscriptionPopupConfig.AFTER_LANDING &&
            cookieValue === null
          ) {
            createCookie(
              subscriptionPopupConfig.COOKIE_NAME,
              0,
              subscriptionPopupConfig.COOKIE_EXPIRES
            );
          }

          function getModalClasses() {
            const windowClass = ['subscription-modal'];
            windowClass.push(jrConfigGlobal.socialLogin.enabled ? 'social' : '');

            return windowClass.join(' ');
          }
        },
      };
    },
  ])
  .directive('jrAutoSubscriptionConfirm', [
    'Messages',
    'SearchFormService',
    'JobseekerConfig',
    'ModalProposalService',
    'GoogleTagManagerService',
    'jrGlobalConfig',
    'VisitConfig',
    'googleOneTapModalConfirmTemplate',
    'modalAutoConfirmSubscriptionTemplate',
    function (
      Messages,
      SearchFormService,
      JobseekerConfig,
      ModalProposalService,
      GoogleTagManagerService,
      jrGlobalConfig,
      VisitConfig,
      googleOneTapModalConfirmTemplate,
      modalAutoConfirmSubscriptionTemplate
    ) {
      return {
        scope: true,
        link(scope) {
          scope.messages = Messages;
          scope.email = JobseekerConfig.email;
          scope.search = SearchFormService.search;
          scope.localeLanguage = jrGlobalConfig.localeLanguage;
          scope.requestComingFromWelcomeEmailAddPassword =
            VisitConfig.requestComingFromWelcomeEmailAddPassword;
          GoogleTagManagerService.pushEvent('jobseekerConfirm');

          ModalProposalService.openModal({
            template: VisitConfig.isOneTapConfirmationFlow
              ? googleOneTapModalConfirmTemplate
              : modalAutoConfirmSubscriptionTemplate,
            scope,
            windowClass: VisitConfig.isOneTapConfirmationFlow
              ? 'google-one-tap-confirm-subscription-modal'
              : 'confirm-subscription-modal',
          });

          jtag('event', 'impression_confirmation_popup');
        },
      };
    },
  ])
  .controller('SerpSubscriptionProposalCtrl', [
    'Messages',
    'SearchConfig',
    'JobseekerConfig',
    'AutocompleteEmailConfig',
    'SearchFormService',
    'SubscriptionService',
    'GoogleTagManagerTrackingService',
    'Banners',
    '$scope',
    '$element',
    'LinkToInboxService',
    'OpenTabService',
    'EventsService',
    'isSubscriptionPopupVisibile',
    function (
      Messages,
      SearchConfig,
      JobseekerConfig,
      AutocompleteEmailConfig,
      SearchFormService,
      SubscriptionService,
      GoogleTagManagerTrackingService,
      Banners,
      $scope,
      $element,
      LinkToInboxService,
      OpenTabService,
      EventsService,
      isSubscriptionPopupVisibile
    ) {
      $scope.messages = Messages;
      $scope.autocompleteEnabled = AutocompleteEmailConfig.enabled;
      $scope.state = JobseekerConfig.email !== undefined ? 'confirm-activation' : 'proposal';
      $scope.jobseekerIsNotConfirmed = JobseekerConfig.isNotConfirmed && !!JobseekerConfig.email;
      $scope.jobseeker = {
        email: JobseekerConfig.email,
      };
      $scope.showProposalModal = isSubscriptionPopupVisibile();
      $scope.hasBeenSubmitted = false;
      $scope.loading = false;
      $scope.errorState = false;
      $scope.subscriptionDaemon = '';
      $scope.forms = {};
      $scope.search = SearchConfig;
      $scope.isEmptySearch = SearchConfig.isEmptySearch;
      $scope.npsBannerEnabled = Banners.npsBannerEnabled;
      EventsService.on.subscriptionSent(function (e, data) {
        $scope.jobseeker.email = data.email;
        $scope.state = 'confirm-activation';
        $scope.$digest();
      });

      $scope.reset = function () {
        $scope.jobseeker = {
          email: undefined,
        };
        $scope.hasBeenSubmitted = false;
        $scope.loading = false;
        $scope.errorState = false;
        $scope.state = 'proposal';
      };

      $scope.submit = function (e) {
        e.preventDefault();

        $scope.hasBeenSubmitted = true;
        if (!$scope.forms.serpProposal.$valid) {
          return;
        }

        let rightSideCaptchaUserResponse;

        if (SearchConfig.isSubscriptionCaptchaEnabled) {
          rightSideCaptchaUserResponse = grecaptcha.getResponse($scope.rightSideCaptcha);
          $scope.captchaUserResponseOk =
            rightSideCaptchaUserResponse !== undefined && rightSideCaptchaUserResponse.length !== 0;
          if (!$scope.captchaUserResponseOk) {
            grecaptcha.reset($scope.rightSideCaptcha);
            $scope.errorState = true;
            return;
          }
        }

        $scope.loading = true;

        SubscriptionService.subscribe(
          $scope.jobseeker.email,
          SearchFormService.search,
          '',
          '',
          '',
          '',
          '',
          '',
          rightSideCaptchaUserResponse
        ).then(function (result) {
          $scope.loading = false;
          if (result.status !== 201) {
            $scope.state = 'proposal';
            $scope.errorState = true;
            return;
          }

          $scope.state =
            SearchConfig.rightsideProposalNewLayoutEnabled &&
            LinkToInboxService.findProvider($scope.jobseeker.email).length
              ? 'link-to-inbox-confirm'
              : 'confirm-activation';

          if (
            $element.hasClass('rightside-proposal') ||
            $element.hasClass('new-rightside-proposal')
          ) {
            if ($element.hasClass('fixed')) {
              GoogleTagManagerTrackingService.trackRightsideBottomSubscription(
                $scope.jobseeker.email
              );
            } else {
              GoogleTagManagerTrackingService.trackRightsideSubscription($scope.jobseeker.email);
            }
          }
        });
      };

      $scope.openLinkToInboxProvider = function (e) {
        e.preventDefault();
        const linkToInboxProviders = LinkToInboxService.findProvider($scope.jobseeker.email);
        if (linkToInboxProviders.length) {
          OpenTabService.open(linkToInboxProviders[0].url);
          $scope.state = 'confirm-activation';
        }
      };

      if (SearchConfig.isSubscriptionCaptchaEnabled) {
        $element.ready(function () {
          $scope.rightSideCaptcha = grecaptcha.render('rightside-captcha-container', {
            sitekey: jrConfigGlobal.captcha.siteKey,
          });
        });
      }
    },
  ])
  .directive('jrRightsideProposal', [
    'jrRightsideProposalTemplate',
    function (jrRightsideProposalTemplate) {
      return {
        replace: true,
        template: jrRightsideProposalTemplate,
      };
    },
  ]);
